// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpBasetagmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpBasetagmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpBasetagmgrIconOutlined = function DrrpBasetagmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpBasetagmgrIconOutlinedSvg
  }));
};

DrrpBasetagmgrIconOutlined.displayName = 'DrrpBasetagmgrIconOutlined';
export default React.forwardRef(DrrpBasetagmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpBasetagmgrIconOutlined.js
// module id = 2491
// module chunks = 0